window.Notice = function () {
    var el = this;
    var $wrapper = $('#notice-wrapper');

    el.show = function (html, x, y) {
        x = x === undefined ? ($(window).width() - $wrapper.width()) / 2 : x;
        y = y === undefined ? ($(window).height() - $wrapper.height()) / 2 : y + $(window).scrollTop();;
        
        $('#notice').removeClass('hide');
        $wrapper.html(html);
        $wrapper.offset({
            left: x,
            top: y
        });
    };

    el.hide = function () {
        $('#notice').addClass('hide');
    };
    
    $(document).on('click', '#notice', function() {el.hide();});
};